import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import Screen from "@components/Screen";


import "./styles.css";
import { useCommunity } from "contexts/community";

import { UserAvatar } from "@components/Community";

import api from "@helpers/api";
import { AlternateEmailRounded, ArrowRightRounded, FingerprintRounded, MailRounded, PhoneRounded, RestartAltRounded, SlowMotionVideoRounded } from "@mui/icons-material";
import { SubscriptionTable } from "@components/Community/Tables/SubscriptionTable";
import { ChargesTable } from "@components/Community/Tables/ChargesTable";

import Parser from '@helpers/parser';

export default function Member() {
    let { id } = useParams();

    id = parseInt(id);

    const [info, setInfo] = useState(null);

    const { community, loadCommunities, loading: communityLoading } = useCommunity();

    document.title = "Detalhes do usuário";

    useEffect(() => {
        if (!id) window.navigate("/communities");
    }, [id]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!communityLoading) loadUser();
    }, [id, communityLoading]);


    async function loadUser() {
        setLoading(true);

        try {
            const searchStr = "community/member/details?user_id=" + id;

            const { data } = await api.get(searchStr);

            console.log('User loaded here')
            console.log(data);

            setInfo({ ...data });
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    }

    const Container = useMemo(
        () => (
            <>
                <Screen
                    loading={loading}
                    className="member px-3 pb-9"
                    key={id}
                    title={[
                        {
                            "title": "Assinaturas",
                            "url": "banking/subscriptions",
                            iconLeft: <RestartAltRounded />
                        },
                        {
                            "title": info?.username ? info?.username : "Carregando...",
                        }
                    ]}
                >

                    <div className="member-container">
                        <MemberInfoHeader info={info} />
                        <SubscriptionTable userId={id} />
                        <ChargesTable userId={id} displayTitle={true} />
                    </div>
                </Screen>
            </>
        ),
        [id, info]
    );

    return id && Container;
}



function MemberInfoHeader({ info }) {
    return (
        <div className="member-info mt-3 mb-4">
            <UserAvatar user={info} size={95} loading={!info} />
            <div>
                <h2 className="member-name" >
                    <h2>{info?.username}</h2>
                    {info?.nickname &&
                        <span style={{ display: "flex", opacity: 0.6, gap: "2px", alignItems: "center" }}>
                            <AlternateEmailRounded style={{ width: "18px", height: "18px" }} />
                            {info?.nickname}
                        </span>
                    }</h2>
                <div className="member-info-details" style={{marginTop: '2px'}}>
                    <MailRounded style={{height: '16px', marginRight: '-3px', width: "16px"}} />
                    <span>{info?.email?.address}</span>
                </div>
                <div className="member-info-details" style={{marginTop: '2px'}}>
                    <PhoneRounded style={{height: '16px', marginRight: '-3px', width: "16px"}} />
                    <span>{info?.phone?.number ? Parser.phone(info.phone.number) : '-'}</span>
                </div>
                {
                    info?.document && <div className="member-info-details" style={{marginTop: '2px'}}>
                        <FingerprintRounded style={{height: '16px', marginRight: '-3px', width: "16px"}} />
                        <span>{Parser.cpf(info?.document)}</span>
                    </div>
                }
            </div>
        </div>
    );
}
